import { classicFormatMaxTwoDigits } from '@/utils/hooks/format/useFormatNumber';

// Lib
import { SIZE_50 } from '@/lib/gridElements/size';

// Components
import { LineChart } from '@/components/composite/Charts/LineChart';
import { Trans } from '@/components/tools/translation';

export const followerGrowthConfig = {
    title: 'chart.instagram.follower_growth',
    margin: { left: -20, right: 10 },
    name: {
        date: 'date',
        estimated: 'estimated_data',
        value: 'chart.instagram.follower_growth_name',
        evolution: 'evolution',
        avg: 'chart.instagram.follower_growth'
    },
    id: 'followers_history',
    color: {
        value: 'blue',
        avg: 'gray',
        estimated: 'blue',
        unavailable: 'gray'
    },
    legendTypes: {
        value: 'line',
        unavailable: 'square'
    },
    valueFormat: classicFormatMaxTwoDigits,
    tooltip: (
        <Trans
            i18nKey="analytics:chart.instagram.follower_growth_tooltip"
            components={{ br: <br /> }}
        />
    ),
    size: SIZE_50,
    type: 'chart',
    isXAxisDate: true,
    noDataToken: 'chart.instagram.no_data_history_period',
    element: LineChart
};
